import loadable from '@loadable/component';

import './TripInformation.css';

export default loadable(() => {
  return import('./TripInformation');
});
